import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';

const bannerImages = [
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20dramatic%20scene%20with%20dark%20atmospheric%20lighting%2C%20mysterious%20character%20silhouette%2C%20urban%20fantasy%20aesthetic%2C%20deep%20teal%20and%20dark%20green%20color%20scheme%2C%20cinematic%20composition%2C%20moody%20ambiance%2C%20digital%20art%20style%2C%20high%20contrast%2C%20artistic%20background&width=1920&height=900&seq=banner-01-home&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20epic%20scene%20with%20magical%20elements%2C%20ancient%20temple%20ruins%20in%20mist%2C%20ethereal%20glowing%20lights%2C%20dark%20emerald%20and%20deep%20teal%20tones%2C%20cinematic%20lighting%2C%20digital%20painting%20style%2C%20atmospheric%20and%20mysterious&width=1920&height=900&seq=banner-02-home&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20scene%20with%20sword%20warrior%20in%20dynamic%20pose%2C%20dramatic%20wind%20effects%2C%20dark%20moody%20lighting%20with%20golden%20accents%2C%20ink%20wash%20artistic%20style%2C%20powerful%20composition%2C%20cinematic%20atmosphere&width=1920&height=900&seq=banner-03-home&orientation=landscape',
];

const bannerData = [
  { slug: 'shadow-hunter', title: '暗影猎手', subtitle: '首尔暗影之下，猎手觉醒' },
  { slug: 'demon-king-reborn', title: '魔王重生', subtitle: '千年魔王，现代重生' },
  { slug: 'magic-academy', title: '魔法学院的劣等生', subtitle: '无魔力的少年，远古的力量' },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % bannerData.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + bannerData.length) % bannerData.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="relative h-[520px] md:h-[700px] w-full overflow-hidden">
      {bannerImages.map((img, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={img}
            alt={bannerData[i].title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-2xl">
              <p className="text-primary-300 text-sm md:text-base font-medium mb-3 md:mb-4 tracking-wider animate-[fadeInUp_0.6s_ease-out]">
                韩漫在线观看 · 免费下拉式阅读
              </p>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 md:mb-6 animate-[fadeInUp_0.6s_ease-out_0.1s]">
                发现最精彩的<br />韩国漫画全集
              </h1>
              <p className="text-white/70 text-sm md:text-base leading-relaxed mb-6 md:mb-8 max-w-lg animate-[fadeInUp_0.6s_ease-out_0.2s]">
                高清画质，流畅下拉式阅读体验。收录数千部热门韩漫作品，每日更新，随时随地畅读您喜爱的漫画。
              </p>
              <div className="flex flex-col sm:flex-row gap-3 animate-[fadeInUp_0.6s_ease-out_0.3s]">
                <Link
                  to="/category/romance"
                  className="inline-flex items-center justify-center px-7 py-3 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  开始阅读
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
                <Link
                  to="/category/action"
                  className="inline-flex items-center justify-center px-7 py-3 rounded-full border border-white/40 text-white text-sm font-medium hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
                >
                  热门排行
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white cursor-pointer transition-colors"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white cursor-pointer transition-colors"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {bannerData.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              i === current ? 'bg-white w-6' : 'bg-white/40 hover:bg-white/60'
            }`}
            aria-label={`切换到第${i + 1}张`}
          />
        ))}
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 md:h-32 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}